export function clearPhone(phoneDirty: string) {
  return phoneDirty.replace(/[^+\d]/g, '');
}
